module.exports = __webpack_public_path__ + "static/media/11 action 1.d6c1523d.JPG";